<div class="project-create-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">Create New Project</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="onCancel()"
      [disabled]="isSubmitting()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="projectForm" (ngSubmit)="onSubmit()">
    <!-- Modal Content -->
    <div class="modal-content">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Project Name</mat-label>
        <input
          matInput
          formControlName="name"
          placeholder="Enter project name"
          required
        />
        @if (projectForm.get("name")?.hasError("required")) {
          <mat-error> Project name is required </mat-error>
        }
        @if (projectForm.get("name")?.hasError("minlength")) {
          <mat-error> Project name must be at least 3 characters </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          formControlName="description"
          placeholder="Enter project description"
          rows="3"
        ></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Workflow Name</mat-label>
        <input
          matInput
          formControlName="workflowName"
          placeholder="Enter workflow name"
          required
        />
        @if (projectForm.get("workflowName")?.hasError("required")) {
          <mat-error> Workflow name is required </mat-error>
        }
        @if (projectForm.get("workflowName")?.hasError("minlength")) {
          <mat-error> Workflow name must be at least 2 characters </mat-error>
        }
      </mat-form-field>

      @if (errorMessage()) {
        <div class="error-message">
          {{ errorMessage() }}
        </div>
      }
    </div>

    <!-- Modal Actions -->
    <div class="modal-actions">
      <button
        class="cancel-button"
        type="button"
        (click)="onCancel()"
        [disabled]="isSubmitting()"
      >
        Cancel
      </button>
      <button
        class="create-button"
        type="submit"
        [disabled]="projectForm.invalid || isSubmitting()"
      >
        @if (isSubmitting()) {
          <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
        }
        @if (!isSubmitting()) {
          <span>Create Project</span>
        }
      </button>
    </div>
  </form>
</div>
